import { formatText } from '~/cynqueModules/formatText'

declare module 'vue' {
  interface ComponentCustomProperties {
    $formatText(val: string | undefined | null): string
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.globalProperties.$formatText = (
    val: string | undefined | null
  ) => {
    return formatText(val)
  }
})
